import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState,useEffect } from "react";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { Home, Articoli, NotFound, Galleria, SingoloArticolo } from "./pages";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";

import './App.css';

//Dati google sheet
const SHEET_ID = "1wAwm6xywNQR_xI9_7AeK_14fxG7AS1-XRd7ySPXS5P8";
const API_KEY = "AIzaSyBmV97RLXv72XbVL8rsaZdIzdk_ETYxwc8";
const RANGE="B:K";

function App() {
  // Stato per gli articoli
  const [articles, setArticles] = useState([]);
  const [photos,setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Funzione per caricare i dati da Google Sheets
  useEffect(() => {
    fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`)
      .then(response => response.json())
      .then(data => {
        if (data.values) {
          const rows = data.values.slice(2);
  
          // Filtra solo le righe con contenuti validi per gli articoli
          const filteredArticleRows = rows.filter(row =>
            row[5] && row[6] && row[9] // Controlla che ci siano id, titolo e testo
          );
  
          const articlesData = filteredArticleRows.map(row => ({
            id: row[5],
            title: row[6],
            date: row[7] || "Data sconosciuta",
            author: row[8] || "Anonimo",
            text: row[9],
          }));
  
          const photoData = rows
            .filter(row => row[0] && row[1]) // anche qui puoi filtrare se vuoi evitare "foto vuote"
            .map(row => ({
              id: row[0],
              link: row[1],
              title: row[2] || "Senza titolo",
              description: row[3] || "Nessuna descrizione",
            }));
  
          setArticles(articlesData);
          setPhotos(photoData);
        } else {
          setError("Errore nel formato dei dati");
        }
      })
      .catch(error => setError("Errore nel recupero dei dati: " + error))
      .finally(() => setLoading(false));
  }, []);
  

  // Arrays con nomi pagine
  const pagesLeft=["Home","Articoli","Galleria"];
  const pagesRight=[];

  return (
    <Router>
      <ScrollToTop></ScrollToTop>
      {loading ? (
        <div className="loading-screen">
          <LoadingScreen></LoadingScreen>
        </div>
      ) : error ? (
        <div className="error-screen">
          <p>Errore</p>
      </div>
      ) : (
        <Routes>
        {/* Home page, raggiungibile anche se nel link non c'è nulla */}
        <Route path="" element={<Home pagesLeft={pagesLeft} pagesRight={pagesRight} articles={articles}/>} />
        <Route path="/home" element={<Home pagesLeft={pagesLeft} pagesRight={pagesRight} articles={articles}/>} />
        {/* Articoli e route per l'articolo singolo */}
        <Route path="/articoli" element={<Articoli pagesLeft={pagesLeft} pagesRight={pagesRight} articles={articles}/>} />
        <Route path="/articoli/:id" element={<SingoloArticolo pagesLeft={pagesLeft} pagesRight={pagesRight} articles={articles}/>} />

        {/* Altra pagine raggiungibili da chiunque */}
        <Route path="/galleria" element={<Galleria pagesLeft={pagesLeft} pagesRight={pagesRight} photos={photos}/>} />

        {/* Not found page */}
        <Route path="*" element={<NotFound pagesLeft={pagesLeft} pagesRight={pagesRight}/>} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
